// Browser-scoped anonymous id used so unauthenticated visitors can still
// toggle reactions (thumbs up / heart) on community posts.
export function getAnonId() {
  let id = localStorage.getItem("mpire_anon_id");
  if (!id) {
    id = (crypto?.randomUUID?.() || `a-${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem("mpire_anon_id", id);
  }
  return id;
}
